<template>
  <div class="animated fadeIn">
    <div class="card">
      <h4
        class="card-header"
        v-if="this.$route.params.ecommerceId === undefined"
      >
        Novo e-commerce
      </h4>
      <h4
        class="card-header"
        v-if="this.$route.params.ecommerceId !== undefined"
      >
        Atualizar e-commerce
      </h4>
      <div class="container">
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-1"
                label="Nome:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.name"
                  required
                  placeholder="Nome e-commerce"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-2"
                label="Nome amigável:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.friendlyName"
                  required
                  placeholder="friendlyName"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-1"
                label="E-mail:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.contact.email"
                  required
                  placeholder="E-mail"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                id="input-group-7"
                label="Telefone:"
                label-for="input-7"
              >
                <the-mask
                  :mask="'+55 (##) #####-####'"
                  class="form-control"
                  id="input-7"
                  v-model="form.contact.phoneNumber"
                  required
                  placeholder="Telefone"
                />
              </b-form-group>
            </div>
          </div>
          <div class="card">
            <div class="row">
              <div style="margin-left: 2%" class="col-sm"><b>Endereço</b></div>
            </div>
            <div class="row">
              <div style="margin-left: 2%" class="col-sm">
                <b-form-group
                  id="input-group-1"
                  label="Rua:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.address.street"
                    required
                    placeholder="Rua"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm">
                <b-form-group
                  id="input-group-1"
                  label="Bairro:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.address.neighborhood"
                    required
                    placeholder="Bairro"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm">
                <b-form-group
                  id="input-group-1"
                  label="Complemento:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.address.complement"
                    placeholder="Complemento"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div style="margin-right: 2%" class="col-sm">
                <b-form-group
                  id="input-group-2"
                  label="Número:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.address.number"
                    required
                    placeholder="Número"
                    @change="
                      form.address.number = parseInt(form.address.number)
                    "
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div style="margin-left: 2%" class="col-sm">
                <b-form-group
                  id="input-group-7"
                  label="CEP:"
                  label-for="input-7"
                >
                  <the-mask
                    :mask="['#####-###']"
                    class="form-control"
                    id="input-7"
                    v-model="form.address.zipCode"
                    required
                    placeholder="CEP"
                  />
                </b-form-group>
              </div>

              <div class="col-sm">
                <b-form-group
                  id="input-group-1"
                  label="Cidade:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.address.city"
                    required
                    placeholder="Cidade"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div style="margin-right: 2%" class="col-sm">
                <b-form-group
                  id="input-group-8"
                  label="Estado:"
                  label-for="input-8"
                >
                  <b-form-select
                    id="input-8"
                    v-model="form.address.state"
                    required
                    :options="states"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-3"
                label="Número banco:"
                label-for="input-3"
              >
                <the-mask
                  :mask="['####']"
                  class="form-control"
                  id="input-3"
                  v-model="form.bankCode"
                  required
                  placeholder="bankCode"
                />
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-4"
                label="Agência (sem dígito verificador):"
                label-for="input-4"
              >
                <the-mask
                  :mask="['#####']"
                  class="form-control"
                  id="input-4"
                  v-model="form.branch"
                  required
                  placeholder="branch"
                />
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-5"
                label="Número da conta (com dígito verificador):"
                label-for="input-5"
              >
                <b-form-input
                  id="input-5"
                  v-model="form.accountNumber"
                  required
                  placeholder="accountNumber"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-6"
                label="Tipo de conta:"
                label-for="input-6"
              >
                <b-form-select
                  id="input-6"
                  v-model="form.accountType"
                  required
                  :options="accountType"
                ></b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-7"
                label="CNPJ:"
                label-for="input-7"
              >
                <the-mask
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                  class="form-control"
                  id="input-7"
                  v-model="form.cnpj"
                  required
                  placeholder="cnpj"
                />
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-8"
                label="Plataforma:"
                label-for="input-8"
              >
                <b-form-select
                  id="input-8"
                  v-model="form.platform"
                  required
                  :options="platformType"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-9"
                label="Nome da conta bancária:"
                label-for="input-9"
              >
                <b-form-input
                  id="input-9"
                  v-model="form.nameBankAccount"
                  required
                  placeholder="nameBankAccount"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-20"
                label="Banco:"
                label-for="input-20"
              >
                <b-form-select
                  id="input-20"
                  v-model="form.bank"
                  required
                  :options="bank"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-10"
                label="Faturamento mensal aproximado:"
                label-for="input-10"
              >
                <money
                  id="input-10"
                  v-model.lazy="form.billingApproximateMonthly"
                  placeholder="Faturamento mensal"
                  v-bind="money"
                  class="form-control"
                ></money>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-11"
                label="Limite de crédito mensal sugerido:"
                label-for="input-11"
              >
                <money
                  id="input-11"
                  v-model.lazy="form.creditLimitSuggestedMonthly"
                  placeholder="Limite de crédito"
                  v-bind="money"
                  class="form-control"
                ></money>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-12"
                label="Tempo expiração do pedido (minutos):"
                label-for="input-12"
              >
                <b-form-input
                  id="input-12"
                  @change="form.timeToExpire = parseInt(form.timeToExpire)"
                  v-model="form.timeToExpire"
                  required
                  placeholder="Tempo expiração do pedido"
                  type="number"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <b-form-group
            id="input-group-13"
            label="Opções do vendedor:"
            label-for="input-13"
          >
            <!--            <b-form-input-->
            <!--              id="input-13"-->
            <!--              v-model="form.sellerOptions"-->
            <!--              placeholder="sellerOptions"-->
            <!--            ></b-form-input>-->
            <!--            <vue-json-editor v-model="form.sellerOptions" :show-btns="true" :expandedOnStart="true" @json-change="onJsonChange"></vue-json-editor>-->
            <vue-json-editor
              v-model="sellerOptionsParsed"
              :show-btns="false"
              :expandedOnStart="true"
              @json-change="onJsonChange"
              mode="code"
            ></vue-json-editor>
          </b-form-group>

          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-14"
                label="Taxas de comissão percentual:"
                label-for="input-14"
              >
                <div class="input-group mb-3">
                  <money
                    class="form-control"
                    id="input-14"
                    v-model="form.percentageCommissionFee"
                    v-bind="percentFee"
                    placeholder="percentageCommissionFee"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-15"
                label="Taxa de comissão indexada:"
                label-for="input-15"
              >
                <div class="input-group mb-3">
                  <money
                    class="form-control"
                    id="input-15"
                    v-model="form.indexedCommissionFee"
                    placeholder="indexedCommissionFee"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-16"
                label="Habilitar e-commerce:"
                label-for="input-16"
              >
                <b-form-checkbox
                  class="checkEnable"
                  id="checkbox-16"
                  v-model="form.enable"
                >
                  <div>{{ form.enable ? "Habilitado" : "Não habilitado" }}</div>
                </b-form-checkbox>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group
                id="input-group-15"
                label="Logo (jpg, jpeg e png):"
                label-for="input-15"
              >
                <b-form-file
                  class="form-control styleBugBorder"
                  browse-text="Procurar"
                  accept="image/png, image/jpeg, image/jpg"
                  id="input-15"
                  ref="file-input"
                  v-model="form.logo"
                  @change="saveLogoFile($event.target.files[0])"
                  placeholder="Escolha um logo"
                  drop-placeholder="Solte o arquivo..."
                >
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge variant="secondary">{{ names[0] }}</b-badge>
                  </template>
                </b-form-file>
                <b-row class="col-sm">
                  <div>
                    {{ form.logo ? form.logo.name : "" }}
                    <i
                      :class="'icon-trash btnDelete'"
                      v-show="form.logo"
                      @click="clearFiles"
                      v-b-tooltip.hover
                      title="Excluir"
                    ></i>
                  </div>
                </b-row>
              </b-form-group>
            </div>
          </div>

          <b-form-group
            id="input-group-16"
            label="Middleware Url:"
            label-for="input-16"
          >
            <b-form-input
              id="input-16"
              v-model="form.middlewareUrl"
              placeholder="middlewareUrl"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-17"
            label="Link relatório de conciliação:"
            label-for="input-17"
          >
            <b-form-input
              id="input-17"
              v-model="form.conciliationReportLink"
              placeholder="Link conciliação"
            ></b-form-input>
          </b-form-group>

          <div class="row">
            <div class="col-sm">
              <b-form-group label="AccountTypeTvm:">
                <b-form-input
                  @change="form.accountTypeTvm = parseInt(form.accountTypeTvm)"
                  v-model="form.accountTypeTvm"
                  placeholder="accountTypeTvm"
                  type="number"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="BrazilianPaymentSystemBankId:">
                <b-form-input
                  v-model="form.brazilianPaymentSystemBankId"
                  placeholder="brazilianPaymentSystemBankId"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="DaysPaymentRelease:">
                <b-form-input
                  @change="
                    form.daysPaymentRelease = parseInt(form.daysPaymentRelease)
                  "
                  v-model="form.daysPaymentRelease"
                  placeholder="daysPaymentRelease"
                  type="number"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group label="CommunicationType:">
                <b-form-select
                  v-model="form.communicationType"
                  :options="communicationTypeOption"
                ></b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="SplitBiz:">
                <b-form-checkbox class="checkEnable" v-model="form.splitBiz">
                  <div>
                    {{ form.splitBiz ? "Habilitado" : "Não habilitado" }}
                  </div>
                </b-form-checkbox>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="CreditApiVersion:">
                <b-form-select
                  v-model="form.creditApiVersion"
                  :options="creditApiVersionOption"
                >
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <b-form-group label="PixKey:">
                <b-form-input
                  v-model="form.pixKey"
                  placeholder="pixKey"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <b-form-group
                id="input-group-14"
                label="Dashboard Url"
                label-for="input-14"
              >
                <div class="input-group mb-3">
                  <b-form-input
                    id="input-18"
                    v-model="form.dashboardUrl"
                    placeholder="Link dashboard"
                  ></b-form-input>
                  <b-tooltip
                    target="button-18"
                    :show.sync="showTooltip1"
                    triggers="click"
                  >
                    Copiado!
                  </b-tooltip>
                  <button
                    id="button-18"
                    v-b-tooltip.hover="'Copiar'"
                    @click="copyToClipboard(form.dashboardUrl, '1')"
                    type="button"
                    class="input-group-append input-group-text"
                  >
                    <i class="icon-file-copy" />
                  </button>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                id="input-group-14"
                label="Url Report Pagamento"
                label-for="input-14"
              >
                <div class="input-group mb-3">
                  <b-form-input
                    id="input-19"
                    v-model="form.paymentUrl"
                    placeholder="Link report pagamento"
                  ></b-form-input>
                  <b-tooltip
                    target="button-19"
                    :show.sync="showTooltip2"
                    triggers="click"
                  >
                    Copiado!
                  </b-tooltip>
                  <button
                    id="button-19"
                    v-b-tooltip.hover="'Copiar'"
                    @click="copyToClipboard(form.paymentUrl, '2')"
                    type="button"
                    class="input-group-append input-group-text"
                  >
                    <i class="icon-file-copy" />
                  </button>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                id="input-group-14"
                label="Url Report Produto"
                label-for="input-14"
              >
                <div class="input-group mb-3">
                  <b-form-input
                    id="input-20"
                    v-model="form.productsUrl"
                    placeholder="Link report de produto"
                  ></b-form-input>
                  <b-tooltip
                    target="button-20"
                    :show.sync="showTooltip3"
                    triggers="click"
                  >
                    Copiado!
                  </b-tooltip>
                  <button
                    id="button-20"
                    v-b-tooltip.hover="'Copiar'"
                    @click="copyToClipboard(form.productsUrl, '3')"
                    type="button"
                    class="input-group-append input-group-text"
                  >
                    <i class="icon-file-copy" />
                  </button>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                id="input-group-18"
                label="fdic:"
                label-for="input-group-18"
              >
                <b-form-select
                  id="input-21"
                  v-model="form.fdic"
                  :options="fdic"
                >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                id="input-group-19"
                label="Tipo de Jornada:"
                label-for="input-group-19"
              >
                <b-form-select
                  id="input-22"
                  v-model="form.journeyType"
                  :options="journeyType"
                >
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <!-- ADD MAQUININHA -->

          <div
            class="row"
            v-for="(i, index) in form.sellerPosList"
            :key="'index ' + index"
          >
            <div class="col-sm">
              <b-form-group label="Nome (Maquininha):">
                <b-form-input
                  v-model="i.name"
                  placeholder="Nome maquininha"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="Serial Number (Maquininha):">
                <b-form-input
                  v-model="i.serialNumber"
                  placeholder="Serial Number"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="CNPJ (Maquininha):">
                <b-form-input
                  v-model="i.cnpj"
                  placeholder="CNPJ"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm">
              <b-form-group label="Habilitar (Maquininha):">
                <b-form-checkbox
                  class="checkEnableSellerPos"
                  v-model="i.active"
                >
                  <div>{{ i.active ? "Habilitado" : "Não habilitado" }}</div>
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

          <b-button
            type="submit"
            variant="primary"
            v-if="this.$route.params.ecommerceId === undefined"
            >{{ loading ? "Por favor aguarde" : "Salvar" }}</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            v-if="this.$route.params.ecommerceId !== undefined"
            >{{ loading ? "Por favor aguarde" : "Atualizar" }}</b-button
          >
          <b-button
            type="reset"
            variant="danger"
            v-if="this.$route.params.ecommerceId === undefined"
            >Resetar campos</b-button
          >
          <b-button
            type="button"
            variant="success"
            @click="handleInputSellerPos"
            >+ maquininha</b-button
          >
        </b-form>
        <!-- <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
import vueJsonEditor from 'vue-json-editor'

export default {
  components: { Money, vueJsonEditor },

  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      percentFee: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 4,
        masked: false /* doesn't work with directive */
      },
      form: {
        name: '',
        friendlyName: '',
        contact: {
          email: '',
          phoneNumber: ''
        },
        address: {
          street: '',
          neighborhood: '',
          number: '',
          city: '',
          state: null,
          complement: '',
          zipCode: ''
        },
        bankCode: '',
        branch: '',
        accountNumber: '',
        accountType: null,
        bank: null,
        cnpj: '',
        platform: null,
        nameBankAccount: '',
        sellerOptions: '',
        percentageCommissionFee: 0.0,
        indexedCommissionFee: 0.0,
        enable: true,
        middlewareUrl: '',
        conciliationReportLink: '',
        sellerPosList: [],
        timeToExpire: 0,
        logo: null,
        newLogo: false,
        logoUrl: '',
        billingApproximateMonthly: 0.0,
        creditLimitSuggestedMonthly: 0.0,
        dashboardUrl: '',
        paymentUrl: '',
        productsUrl: '',
        fdic: null,
        journeyType: null,
        accountTypeTvm: null,
        brazilianPaymentSystemBankId: null,
        pixKey: null,
        daysPaymentRelease: 0,
        splitBiz: false,
        communicationType: null,
        creditApiVersion: null
      },
      sellerOptionsParsed: null,
      logoFile: null,
      accountType: [],
      bank: [],
      communicationTypeOption: [
        { text: 'Selecione', value: null },
        { text: 'email', value: 'email' },
        { text: 'sms', value: 'sms' },
        { text: 'email-sms', value: 'email-sms' }
      ],
      creditApiVersionOption: [
        { text: 'Selecione', value: null },
        { text: 'BOLETOFLEX', value: 'BOLETOFLEX' },
        { text: 'OPENCO', value: 'OPENCO' }
      ],
      platformType: [
        { text: 'Selecione', value: null },
        { text: 'Vtex', value: 'Vtex' },
        { text: 'Magento', value: 'Magento' },
        { text: 'Arco', value: 'Arco' },
        { text: 'Nuvemshop', value: 'Nuvemshop' },
        { text: 'Traycorp', value: 'Traycorp' },
        { text: 'Própria', value: 'Própria' }
      ],
      states: [
        { text: 'Selecione', value: null },
        {
          text: 'Acre',
          value: 'AC'
        },
        {
          text: 'Alagoas',
          value: 'AL'
        },
        {
          text: 'Amapá',
          value: 'AP'
        },
        {
          text: 'Amazonas',
          value: 'AM'
        },
        {
          text: 'Bahia',
          value: 'BA'
        },
        {
          text: 'Ceará',
          value: 'CE'
        },
        {
          text: 'Distrito Federal',
          value: 'DF'
        },
        {
          text: 'Espírito Santo',
          value: 'ES'
        },
        {
          text: 'Goiás',
          value: 'GO'
        },
        {
          text: 'Maranhão',
          value: 'MA'
        },
        {
          text: 'Mato Grosso',
          value: 'MT'
        },
        {
          text: 'Mato Grosso do Sul',
          value: 'MS'
        },
        {
          text: 'Minas Gerais',
          value: 'MG'
        },
        {
          text: 'Pará',
          value: 'PA'
        },
        {
          text: 'Paraíba',
          value: 'PB'
        },
        {
          text: 'Paraná',
          value: 'PR'
        },
        {
          text: 'Pernambuco',
          value: 'PE'
        },
        {
          text: 'Piauí',
          value: 'PI'
        },
        {
          text: 'Rio de Janeiro',
          value: 'RJ'
        },
        {
          text: 'Rio Grande do Norte',
          value: 'RN'
        },
        {
          text: 'Rio Grande do Sul',
          value: 'RS'
        },
        {
          text: 'Rondônia',
          value: 'RO'
        },
        {
          text: 'Roraima',
          value: 'RR'
        },
        {
          text: 'Santa Catarina',
          value: 'SC'
        },
        {
          text: 'São Paulo',
          value: 'SP'
        },
        {
          text: 'Sergipe',
          value: 'SE'
        },
        {
          text: 'Tocantins',
          value: 'TO'
        }
      ],
      show: true,
      showTooltip1: false,
      showTooltip2: false,
      showTooltip3: false,
      loading: false,
      fdic: [],
      journeyType: []
    }
  },
  mounted () {
    if (this.$route.params.ecommerceId !== undefined) {
      this.getEcommerce()
    }
    this.getAccountType()
    this.getBank()
    this.getFdic()
    this.getJourneyType()
  },
  methods: {
    handleInputSellerPos () {
      this.form.sellerPosList.push({
        name: '',
        serialNumber: '',
        cnpj: '',
        active: true
      })
    },
    clearFiles () {
      this.form.newLogo = false
      this.$refs['file-input'].reset()
    },
    getBank () {
      this.$http
        .get('api/sellers/bank')
        .then(function (res) {
          let bankItem = res.data.list
          this.bank = [{ text: 'Selecione', value: null }, ...bankItem]
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getAccountType () {
      this.$http
        .get('api/sellers/account')
        .then(function (res) {
          let account = res.data.list
          this.accountType = [{ text: 'Selecione', value: null }, ...account]
          // this.accountType = res.data.list
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getFdic () {
      this.$http
        .get('api/sellers/fdic')
        .then(function (res) {
          let data = res.data.list
          this.fdic = [{ text: 'Selecione', value: null }, ...data]
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getJourneyType () {
      this.$http
        .get('api/sellers/journeyType')
        .then(function (res) {
          let data = res.data.list
          this.journeyType = [{ text: 'Selecione', value: null }, ...data]
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getEcommerce () {
      this.$http
        .get('api/sellers/' + this.$route.params.ecommerceId)
        .then(function (res) {
          console.log(res.data)
          this.form.name = res.data.name
          this.form.friendlyName = res.data.friendlyName
          this.form.bankCode = res.data.bankCode
          this.form.branch = res.data.branch
          this.form.address =
            res.data.address !== null
              ? res.data.address
              : {
                street: '',
                neighborhood: '',
                number: '',
                city: '',
                state: null,
                complement: '',
                zipCode: ''
              }
          this.form.contact =
            res.data.contact !== null
              ? res.data.contact
              : { email: '', phoneNumber: '' }
          this.form.accountNumber = res.data.accountNumber
          this.form.accountType = res.data.accountType
          this.form.bank = res.data.bank
          this.form.cnpj = res.data.cnpj
          this.form.platform = res.data.platform
          this.form.nameBankAccount = res.data.nameBankAccount
          this.form.sellerOptions = res.data.sellerOptions
          this.sellerOptionsParsed = JSON.parse(this.form.sellerOptions)
          this.form.percentageCommissionFee = res.data.percentageCommissionFee
          this.form.indexedCommissionFee = res.data.indexedCommissionFee
          this.form.enable = res.data.enable
          this.form.logo = res.data.logoUrl
          this.form.middlewareUrl = res.data.middlewareUrl
          this.form.conciliationReportLink = res.data.conciliationReportLink
          this.form.timeToExpire = res.data.timeToExpire
          this.form.billingApproximateMonthly =
            res.data.billingApproximateMonthly
          this.form.creditLimitSuggestedMonthly =
            res.data.creditLimitSuggestedMonthly
          this.form.dashboardUrl = JSON.parse(res.data.sellerOptions).dashboard
          this.form.paymentUrl = JSON.parse(res.data.sellerOptions).payment
          this.form.productsUrl = JSON.parse(res.data.sellerOptions).products
          this.form.fdic = res.data.fdic
          this.form.journeyType = res.data.journeyType
          this.form.accountTypeTvm = res.data.accountTypeTvm
          this.form.brazilianPaymentSystemBankId =
            res.data.brazilianPaymentSystemBankId
          this.form.pixKey = res.data.pixKey
          this.form.daysPaymentRelease = res.data.daysPaymentRelease
          this.form.splitBiz = res.data.splitBiz
          this.form.communicationType = res.data.communicationType
          this.form.creditApiVersion = res.data.creditApiVersion
          if (res.data.listSellerPos) {
            this.form.sellerPosList = res.data.listSellerPos
          } else {
            this.form.sellerPosList = []
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (this.$route.params.ecommerceId === undefined) {
        this.save()
      } else {
        this.update()
      }
    },
    async uploadLogo () {
      var formData = new FormData()
      formData.append('file', this.logoFile)
      formData.append('seller', this.form.name)
      await this.$http
        .post(`upload/logo-seller`, formData)
        .then(() => {})
        .catch(() => {})
    },
    async save () {
      this.loading = true
      console.log('Antes save ' + this.sellerOptionsParsed)
      console.log(this.form)
      this.form.sellerOptions = JSON.stringify(this.sellerOptionsParsed)
      // files = URL.createObjectURL(files)
      if (this.newLogo) {
        await this.uploadLogo()
      }
      this.form.logoUrl = `https://storage-bf-img.s3.amazonaws.com/seller/logo/${this.form.name}.png`
      await this.$http
        .post('api/sellers', this.form)
        .then(function (r) {
          this.resetFields()
          this.$bvToast.toast('e-commerce criado com sucesso', {
            // title: 'e-commerce criado com sucesso',
            autoHideDelay: 5000,
            variant: 'success'
          })

          this.loading = false
        })
        .catch(function (response) {
          console.log('Error')
          console.log(response)
          this.$bvToast.toast(
            'Erro ao criar e-commerce: ' + response.body.toString(),
            {
              autoHideDelay: 5000,
              variant: 'danger'
            }
          )

          this.loading = false
        })
    },
    async update () {
      this.loading = true
      // files = URL.createObjectURL(files)
      if (this.form.newLogo) {
        await this.uploadLogo()
      }
      this.form.logoUrl = `https://storage-bf-img.s3.amazonaws.com/seller/logo/${this.form.name}.png`
      console.log('Antes save ' + this.sellerOptionsParsed)
      this.form.sellerOptions = JSON.stringify(this.sellerOptionsParsed)
      await this.$http
        .put('api/sellers/' + this.$route.params.ecommerceId, this.form)
        .then(function (res) {
          this.$bvToast.toast('e-commerce atualizado com sucesso', {
            // title: 'e-commerce atualizado com sucesso',
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.loading = false
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)

          this.$bvToast.toast(
            'Erro ao atualizar e-commerce: ' + res.body.toString(),
            {
              autoHideDelay: 5000,
              variant: 'danger'
            }
          )
          this.loading = true
        })
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.friendlyName = ''
      this.form.bankCode = ''
      this.form.branch = ''
      this.form.accountNumber = ''
      this.form.accountType = null
      this.form.bank = null
      this.form.cnpj = ''
      this.form.platform = null
      this.form.nameBankAccount = ''
      this.form.sellerOptions = ''
      this.form.percentageCommissionFee = 0.0
      this.form.indexedCommissionFee = 0.0
      this.form.enable = false
      this.form.logo = null
      this.form.middlewareUrl = ''
      this.form.conciliationReportLink = ''
      this.form.timeToExpire = 0
      this.form.billingApproximateMonthly = 0.0
      this.form.creditLimitSuggestedMonthly = 0.0
      this.form.sellerPosList = []
      this.form.dashboardUrl = ''
      this.form.paymentUrl = ''
      this.form.productsUrl = ''
      this.form.fdic = null
      this.form.journeyType = null
      this.form.accountTypeTvm = null
      this.form.brazilianPaymentSystemBankId = null
      this.form.pixKey = null
      this.form.daysPaymentRelease = 0
      this.form.splitBiz = false
      this.form.communicationType = null
      this.form.creditApiVersion = null
      this.form.contact = { email: '', phoneNumber: '' }
      this.form.address = {
        street: '',
        neighborhood: '',
        number: '',
        city: '',
        state: null,
        complement: '',
        zipCode: ''
      }
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    resetFields () {
      this.form.name = ''
      this.form.friendlyName = ''
      this.form.bankCode = ''
      this.form.branch = ''
      this.form.accountNumber = ''
      this.form.accountType = null
      this.form.bank = null
      this.form.cnpj = ''
      this.form.platform = null
      this.form.nameBankAccount = ''
      this.form.sellerOptions = ''
      this.form.percentageCommissionFee = 0.0
      this.form.indexedCommissionFee = 0.0
      this.form.enable = false
      this.form.logo = null
      this.form.middlewareUrl = ''
      this.form.conciliationReportLink = ''
      this.form.timeToExpire = 0
      this.form.billingApproximateMonthly = 0.0
      this.form.creditLimitSuggestedMonthly = 0.0
      this.form.sellerPosList = []
      this.form.dashboardUrl = ''
      this.form.paymentUrl = ''
      this.form.productsUrl = ''
      this.form.fdic = null
      this.form.journeyType = null
      this.form.accountTypeTvm = null
      this.form.brazilianPaymentSystemBankId = null
      this.form.pixKey = null
      this.form.daysPaymentRelease = 0
      this.form.splitBiz = false
      this.form.communicationType = null
      this.form.creditApiVersion = null
      this.form.contact = { email: '', phoneNumber: '' }
      this.form.address = {
        street: '',
        neighborhood: '',
        number: '',
        city: '',
        state: null,
        complement: '',
        zipCode: ''
      }
    },
    saveLogoFile (file) {
      this.form.newLogo = true
      this.logoFile = file
    },
    onJsonChange (value) {
      console.log('value:', value)
    },
    copyToClipboard (str, tTip) {
      switch (tTip) {
        case '1':
          this.showTooltip1 = true
          break

        case '2':
          this.showTooltip2 = true
          break

        case '3':
          this.showTooltip3 = true
          break
      }

      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      setTimeout(() => {
        this.showTooltip1 = false
        this.showTooltip2 = false
        this.showTooltip3 = false
      }, 1000)
    }
  },
  watch: {
    '$route.params.ecommerceId' () {
      this.getEcommerce()
    }
  }
}
</script>

<style lang="scss">
.container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.checkEnable {
  margin-top: 15px;
}
.checkEnableSellerPos {
  margin-top: 6px;
}
.styleBugBorder {
  border: 0px solid #ced4da !important;
  overflow: hidden;
}
.btnDelete {
  color: #000;
  cursor: pointer;
  vertical-align: middle;
  &:hover {
    color: red;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ecommerces/EcommerceNew.vue